import { ErrorBase } from "@util/errors";

export class InvalidSalutationTemplateError extends ErrorBase {}

export class UserNotFoundError extends ErrorBase {
	static errorId = "user-not-found";

	constructor(readonly userId: string) {
		super(`Benutzer wurde nicht gefunden. User ID: ${userId}`);
	}

	static fromErrorResponse(payload: any): UserNotFoundError {
		return new UserNotFoundError(payload.userId);
	}
}

export class SendingEmailError extends ErrorBase {}

export class UpdateUserError extends ErrorBase {}

export class ResalutateUnexpectedStateError extends ErrorBase {}

export class InvalidEmailFormatError extends ErrorBase {}

export class PersonalnoConflictError extends ErrorBase {}

export class MoveUserToDivisionAssetsError extends ErrorBase {
	static errorId = "move-to-division-error-user-has-assets";

	constructor() {
		super(
			"Der User kann nicht in einen anderen Standort verschoben werden, da ihm Jobräder zugewiesen sind."
		);
	}
}

export class MoveUserToDivisionSachbezugMonthClosedError extends ErrorBase {
	static errorId = "move-to-division-month-closed-sachbezug";

	constructor() {
		super(
			"Der User kann nicht in einen anderen Standort verschoben werden, da der Sachbezug-Monat geschlossen ist und der User Sachbezug-Gutscheine erhalten hat. Bitte den User ab dem nächsten Monat verschieben oder den Stichtag für „Automatisches Sperren des Vormonats“ anpassen (dies ist bis zum 15. möglich)."
		);
	}
}

export class UserConflictError extends ErrorBase {
	constructor(readonly reason: "email" | "personalNo" | "externalId") {
		const map: Record<typeof reason, string> = {
			email: "E-Mail Adresse wird bereits verwendet",
			personalNo: "Personal-Nummer ist bereits vergeben",
			externalId: "Externe ID ist bereits vergeben",
		};
		super(map[reason]);
	}
}

export class OverlappingUsersError extends ErrorBase {}

export class LinkExternalUserError extends ErrorBase {}

export class UserAssignedAsSuperiorError extends ErrorBase {}

export class CyclicReferenceError extends ErrorBase {}

export class DebitorNumberNotFoundError extends ErrorBase {}
